import { Box, IconButton, Typography } from "@mui/material";
import eyeIcon from "../assets/images/eyeicon.svg";
import closecontained from "../assets/images/closecontained.svg";

import { DocumentViewer } from "../pages/DocumentViewer";
import { useState } from "react";
import pending from "../assets/images/pending.svg";
import approved from "../assets/images/approved.svg";
import rejected from "../assets/images/rejected.svg";
import { useSnapshot } from "valtio";
import { taskStore } from "../mytasks/task-store";
import Utils from "../util/Utils";
import { useMobile } from "../hooks/usemobile";

function getFileStatusColor(fileStatus){
    if(fileStatus==="approve"){
        return {backgroundColor:"#E9F9DC80",src:approved}
    }else if(fileStatus==="reject"){
        return {backgroundColor:"#F25B5B12",src:rejected}
    }else{
        return {backgroundColor:"#EBB02D33",src:pending}
    }
}

export function FileViewComponent({documentTitle,documentUrl,backgroundColor,onRejection,needsApproval,onApprove,onReject,viewFile=true,onRemove,isDeletable=false,width,height,size="small"}){
    const isMobileSize = size==="medium";
    const isMobileDevice = useMobile();
    const isMobile = isMobileSize;
    const fileName = Utils.getFileExtension(documentTitle);
    const fileNameWithoutExtension = Utils.getFileNameWithoutExtension(documentTitle) || documentTitle;
    const fileViewProperties = Utils.getPropertiesForFileExtension(fileName);
    const [open,setOpen] = useState(false);
    
    const boxWidth = width || (isMobile ? "100%" : "200px");
    const boxHeight = height || (isMobile ? "75px" : "40px");

    return <Box sx={{display:"flex",flexDirection:"row",width:boxWidth,maxWidth:"100%",boxSizing:"border-box",backgroundColor:backgroundColor || "white",height:boxHeight,borderRadius:isMobile ? "12px" : "6px",alignItems:"center",border:backgroundColor?"":"1px solid #D4D4D4",gap:isMobile ? 1.5 : 0.5,paddingX:isMobile ? "12px" : "6px",justify:"space-between",overflow:"hidden"}}>
        <Box sx={{display:"flex",justifyContent:"center",alignItems:"center",borderRadius:isMobile ? "10px" : "6px",height:isMobile ? "48px" : "30px",minWidth:isMobile ? "48px" : "30px",backgroundColor:fileViewProperties?.backgroundColor,flexShrink:0}}>
            <img src={fileViewProperties?.icon} style={{ width: isMobile ? "24px" : "18px", height: isMobile ? "24px" : "18px" }} alt="File icon"/>
        </Box>
        <Box sx={{display:"flex",flexDirection:"row",justify:"start",flex:1,overflow:"hidden",alignItems:"center",minWidth:0}}>
            <Typography sx={{fontSize:isMobile ? "14px" : "12px",fontFamily:"Figtree",fontWeight:isMobile ? 600 : 400,marginRight:0,color:isMobile ? "#1E293B" : "#555555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",minWidth:0,flex:1}} title={fileNameWithoutExtension}>{fileNameWithoutExtension}</Typography>
            <Typography sx={{fontSize:isMobile ? "14px" : "12px",fontFamily:"Figtree",fontWeight:isMobile ? 600 : 400,color:isMobile ? "#1E293B" : "#555555",flexShrink:0}}>{"."+fileName}</Typography>
        </Box>
        <Box sx={{display:"flex",alignItems:"center",gap:isMobile ? 0.5 : 0,flexShrink:0}}>
            <IconButton size={isMobile ? "medium" : "small"} onClick={()=>{
                if(isMobileDevice){
                    window.open(documentUrl, '_blank', 'noopener,noreferrer');
                } else {
                    setOpen(true);
                }
            }}><img src={eyeIcon} alt="View" style={{ width: isMobile ? "22px" : "16px", height: isMobile ? "22px" : "16px" }} /></IconButton>
            {(isDeletable || onRemove) && (
                <IconButton size={isMobile ? "medium" : "small"} sx={{padding:isMobile ? 0.5 : 0}} onClick={()=>{
                    if(onRemove) onRemove();
                }}><img src={closecontained} alt="Remove" style={{ width: isMobile ? "22px" : "16px", height: isMobile ? "22px" : "16px" }} /></IconButton>
            )}
        </Box>
      { viewFile && <DocumentViewer isExcel={documentUrl?.includes("xlsx") || documentUrl?.includes("xls")} onApprove={onApprove} onReject={onReject} onRejection={onRejection} needsApproval={needsApproval} documentTitle={documentTitle} documentUrl={documentUrl} open={open} onClose={()=>{
            setOpen(false);
        }}/>}
    </Box>
}
  

export function ApproveOrRejectFile({documentTitle,documentUrl,fileStatus,onRejection,needsApproval,onApprove,onReject}){
    const task = useSnapshot(taskStore).current
    const fileStatusStyle = getFileStatusColor(fileStatus); 
   return  <Box sx={{position:"relative",height:"48px",width:"208px"}}>
        <Box sx={{height:"max-content",width:"max-content",position:"absolute",bottom:0,}}>
            <FileViewComponent onApprove={onApprove} onReject={onReject} needsApproval={needsApproval} onRejection={onRejection} backgroundColor={fileStatusStyle.backgroundColor} documentTitle={documentTitle} documentUrl={documentUrl} />
        </Box>
        <Box sx={{position:"absolute",top:0,right:0,height:"16px",width:"16px"}}><img src={fileStatusStyle.src} /></Box>
    </Box>
}